import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/assets/i18n/{{lng}}.json',
    },
    react: {
      useSuspense: false,
    },
  });

// Make i18n available globally for language switching
declare global {
  interface Window {
    i18n: typeof i18n;
  }
}

window.i18n = i18n;

export default i18n;